import { cifra, tramo } from '../core/componentes.js';
import { balance, balanceAnual, contratoDe, contratosVisibles, importeDe, nivel, servidoPedido, totalPedido } from '../core/dominio.js';
import { S } from '../core/estado.js';
import { anioActual, dias, esc, eurK, fecha, fechaCorta, num } from '../core/formato.js';
import { HOY, db } from '../data/db.js';
import { tablaImputaciones } from './imputaciones.js';
import { tablaPedidos } from './pedidos.js';

/* =====================================================================
   PANEL
   ===================================================================== */
export function vistaPanel(){
  const activos = contratosVisibles(true);
  const total = activos.reduce((s,c)=>s+c.adjudicado,0);
  const gastado = activos.reduce((s,c)=>s+balance(c.id).consumido,0);
  const pendCert = db.imputaciones.filter(i=>i.estado!=='certificada' && contratoDe(i.contrato).estado==='activo').reduce((s,i)=>s+importeDe(i),0);
  const pedAbiertos = db.pedidos.filter(p=>!['servido','anulado'].includes(p.estado) && activos.some(c=>c.id===p.contrato));
  const admin = S.usuario.rol==='admin';
  const soloOperario = S.usuario.rol==='operario';

  const avisos = [];
  activos.forEach(c=>{
    const b = balance(c.id), ba = balanceAnual(c.id, anioActual);
    if(ba.tope && ba.pct>=90) avisos.push({t:ba.pct>=100?'rojo':'ambar', tit:`${c.expediente} · anualidad ${anioActual} al ${num(ba.pct,1)} %`,
      txt: ba.pct>=100 ? `Has superado el tope del ejercicio en ${eurK(-ba.saldo)}. Hay que reajustar anualidades o frenar imputaciones.`
                       : `Quedan ${eurK(ba.saldo)} de los ${eurK(ba.tope)} previstos para este año.`});
    if(b.pct>=78) avisos.push({t:b.pct>=95?'rojo':'ambar', tit:`${c.expediente} · ${num(b.pct,1)} % del importe total`,
      txt:`Saldo de ${eurK(b.saldo)}${b.comprometido?`, con ${eurK(b.comprometido)} ya comprometidos en pedidos sin servir`:''}.`});
    if(b.diasRestantes<=120 && b.diasRestantes>0) avisos.push({t:'ambar', tit:`${c.expediente} vence en ${b.diasRestantes} días`,
      txt:`Fin de vigencia el ${fecha(c.fin)}. ${c.prorroga?'Admite prórroga: tramítala antes del vencimiento.':'No admite prórroga: inicia la licitación del siguiente.'}`});
  });
  const retrasados = pedAbiertos.filter(p=>p.prevista && dias(p.prevista)<0);
  if(retrasados.length) avisos.push({t:'ambar', tit:`${retrasados.length} pedidos fuera de plazo`,
    txt:`Han pasado de la fecha prevista de entrega: ${retrasados.map(p=>p.numero).join(', ')}.`});

  return `
  <div class="page-head">
    <div><div class="eyebrow">${HOY.toLocaleDateString('es-ES',{weekday:'long',day:'numeric',month:'long',year:'numeric'})}</div>
      <h1>Hola, ${esc(S.usuario.nombre.split(' ')[0])}</h1>
      <p>${soloOperario?'Estos son los contratos a los que puedes imputar trabajo y hacer pedidos.':'Situación de los contratos vivos, consumo de la anualidad en curso y avisos.'}</p></div>
    <div style="display:flex;gap:8px;flex-wrap:wrap">
      <button class="btn" data-act="nuevo-pedido">Nuevo pedido</button>
      <button class="btn ${soloOperario?'btn-p':''}" data-act="nueva-imputacion">Registrar trabajo</button>
      ${admin?`<button class="btn btn-p" data-act="nuevo-contrato">Dar de alta contrato</button>`:''}
    </div></div>

  ${!soloOperario?`<div class="grid g4" style="margin-bottom:20px">
    <div class="card card-b">${cifra('Adjudicado vivo', eurK(total), `${activos.length} contratos en ejecución`,'v-azul')}</div>
    <div class="card card-b">${cifra('Consumido', eurK(gastado), `${num(total?gastado/total*100:0,1)} % del total`,'v-verde')}</div>
    <div class="card card-b">${cifra('Sin certificar', eurK(pendCert), 'Trabajo listo para certificar','v-ambar')}</div>
    <div class="card card-b">${cifra('Pedidos abiertos', pedAbiertos.length, `${eurK(pedAbiertos.reduce((s,p)=>s+totalPedido(p)-servidoPedido(p),0))} pendientes de servir`)}</div>
  </div>`:''}

  ${avisos.length&&!soloOperario?`<div style="margin-bottom:20px"><div class="eyebrow" style="margin-bottom:9px">Requiere tu atención</div>
    ${avisos.map(a=>`<div class="aviso a-${a.t}"><div class="txt"><b class="tit">${esc(a.tit)}</b>${esc(a.txt)}</div></div>`).join('')}</div>`:''}

  <div class="eyebrow" style="margin-bottom:10px">Contratos en ejecución · pulsa para entrar en uno</div>
  <div class="grid g2">${activos.map(c=>fichaContrato(c)).join('')||`<div class="card vacio"><h4>Sin contratos${admin?'':' asignados'}</h4>
    <p>${admin?'Da de alta el primero para empezar a registrar trabajo.':'Pide al administrador que te dé acceso a alguno.'}</p></div>`}</div>

  ${!soloOperario?`<div class="grid g2" style="margin-top:22px">
    <div class="card"><div class="card-h"><div><h3>Últimos trabajos</h3><div class="sub">Lo que se ha imputado recientemente</div></div>
      <button class="btn btn-s" data-act="ir" data-v="imputaciones">Ver todo</button></div>
      <div class="tabla-wrap">${tablaImputaciones(db.imputaciones.slice().sort((a,b)=>b.fecha.localeCompare(a.fecha)).slice(0,6), true, true)}</div></div>
    <div class="card"><div class="card-h"><div><h3>Pedidos pendientes</h3><div class="sub">Solicitados, confirmados o servidos a medias</div></div>
      <button class="btn btn-s" data-act="ir" data-v="pedidos">Ver todo</button></div>
      <div class="tabla-wrap">${tablaPedidos(pedAbiertos.slice(0,6), true, true)}</div></div>
  </div>`:''}`;
}

export function fichaContrato(c){
  const b = balance(c.id), ba = balanceAnual(c.id, anioActual), n = nivel(b.pct), dr = b.diasRestantes;
  const nDocs = db.documentos.filter(d=>d.contrato===c.id).length;
  const nPed = db.pedidos.filter(p=>p.contrato===c.id && !['servido','anulado'].includes(p.estado)).length;
  return `<div class="ficha ${c.estado==='cerrado'?'cerrado':''}" data-act="abrir-contrato" data-id="${c.id}">
    <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:10px">
      <div><div class="exp">${esc(c.expediente)}</div><h3>${esc(c.nombre)}</h3>
        <div class="emp">${esc(c.empresa)} · ${esc(c.tipo)}</div></div>
      ${c.estado==='cerrado'?'<span class="tag t-cerrado">Cerrado</span>':'<span class="tag t-activo"><span class="punto"></span>Activo</span>'}</div>
    <div class="chips">
      ${n==='exceso'?'<span class="tag t-critico">Saldo crítico</span>':n==='alerta'?'<span class="tag t-alerta">Consumo alto</span>':''}
      ${ba.tope&&ba.pct>=90?`<span class="tag ${ba.pct>=100?'t-critico':'t-alerta'}">Anualidad ${anioActual} al ${num(ba.pct,0)} %</span>`:''}
      ${c.estado==='activo'&&dr<=120&&dr>0?`<span class="tag t-alerta">Vence en ${dr} días</span>`:''}
      ${c.estado==='activo'&&dr>120?`<span class="tag t-borrador">Vigente hasta ${fechaCorta(c.fin)}</span>`:''}
      ${c.estado==='cerrado'?`<span class="tag t-cerrado">Finalizó ${fechaCorta(c.fin)}</span>`:''}
      ${nPed?`<span class="tag t-solicitado">${nPed} pedidos abiertos</span>`:''}
      ${nDocs?`<span class="tag t-cerrado">${nDocs} documentos</span>`:''}
    </div>
    ${tramo(b)}</div>`;
}

